class JobsBlock {
  /**
   * Add custom JavaScript to the block HTML.
   *
   * @param   Element  block       The block element
   * @param   object   attributes  The block attributes (only available when editing)
   * @return  void
   */
  constructor(block, attributes = null) {
    this.block = block;
    this.items = block.querySelectorAll('.jobs__item');
    this.showingCountEl = block.querySelector('.jobs__count-showing');
    this.resetButton = block.querySelector('.filters__reset');
    this.departmentFilter = block.querySelector(
      `.filters__select[name="jobs-department-filter-${block.dataset.blockId}"]`
    );
    this.commitmentFilter = block.querySelector(
      `.filters__select[name="jobs-commitment-filter-${block.dataset.blockId}"]`
    );
    this.locationFilter = block.querySelector(`.filters__select[name="jobs-location-filter-${block.dataset.blockId}"]`);
    this.keywordsFilter = block.querySelector('.filters__text-input');
    this.showResultsButtonCount = block.querySelector('.filters__show-results-button span');
    this.loadMoreButton = block.querySelector('.jobs__load-more-button');
    this.filterToggle = block.querySelector('.filters__toggle--open');
    this.notFoundMessage = block.querySelector('.jobs__not-found');

    this.getFragmentData();
    this.calcShowingCount();

    this.resetButton.addEventListener('click', () => {
      this.departmentFilter.value = 'all';
      this.commitmentFilter.value = 'all';
      this.locationFilter.value = 'all';
      this.keywordsFilter.value = '';
      this.refresh();
    });

    this.departmentFilter.addEventListener('change', () => this.refresh());
    this.commitmentFilter.addEventListener('change', () => this.refresh());
    this.locationFilter.addEventListener('change', () => this.refresh());
    this.keywordsFilter.addEventListener('keyup', () => this.refresh());
    this.keywordsFilter.addEventListener('change', () => this.refresh());
    this.filterToggle.addEventListener('click', () => setTimeout(() => this.refresh(), 400));

    if (this.loadMoreButton) {
      this.loadMoreButton.addEventListener('click', () => {
        this.refresh();
      });
    }
  }

  /**
   * Get the filter selection from the URL fragment.
   */
  getFragmentData() {
    if (window.location.hash) {
      const parts = window.location.hash.substr(1).split('+');
      const blockId = parts[0];

      parts.forEach((part) => {
        const _parts = part.split('!');

        if (_parts.length === 2) {
          switch (_parts[0]) {
            case 'department':
              this.departmentFilter.value = _parts[1];
              break;
            case 'commitment':
              this.commitmentFilter.value = _parts[1];
              break;
            case 'location':
              this.locationFilter.value = _parts[1];
              break;
          }
        }

        if (parts.length > 1) {
          this.refresh();
          window.location.href = '#' + parts[0];
        }
      });
    }
  }

  /**
   * Refresh the visibility of all job items.
   */
  refresh() {
    this.items.forEach((item) => {
      let visible = true;

      if (this.departmentFilter.value !== 'all' && this.departmentFilter.value !== item.dataset.department) {
        visible = false;
      }

      if (this.commitmentFilter.value !== 'all' && this.commitmentFilter.value !== item.dataset.commitment) {
        visible = false;
      }

      if (this.locationFilter.value !== 'all' && this.locationFilter.value !== item.dataset.location) {
        visible = false;
      }

      if (this.keywordsFilter.value) {
        const needles = this.keywordsFilter.value
          .toLowerCase()
          .trim()
          .replace(/ +(?= )/g, '')
          .split(' ');

        const haystack = `${item.textContent.trim()} ${item.dataset.department} ${item.dataset.commitment} ${
          item.dataset.location
        }`.toLowerCase();

        needles.forEach((needle) => {
          if (!haystack.includes(needle)) {
            visible = false;
          }
        });
      }

      if (visible) {
        item.classList.add('jobs__item--visible');
      } else {
        item.classList.remove('jobs__item--visible');
      }
    });

    this.calcShowingCount();

    if (
      this.departmentFilter.value !== 'all' ||
      this.commitmentFilter.value !== 'all' ||
      this.locationFilter.value !== 'all'
    ) {
      this.filterToggle.classList.add('filters__toggle--active');
    } else {
      this.filterToggle.classList.remove('filters__toggle--active');
    }

    if (this.loadMoreButton) {
      this.loadMoreButton.parentElement.removeChild(this.loadMoreButton);
      this.loadMoreButton = null;
    }
  }

  /**
   * Count the visible job items.
   */
  calcShowingCount() {
    const count = Array.from(this.items).filter((item) => item.classList.contains('jobs__item--visible')).length;

    this.showingCountEl.textContent = count;
    this.showResultsButtonCount.textContent = count;
    this.notFoundMessage.style.display = count ? 'none' : 'block';
  }
}

// Initialize each block on page load (front end)
document.querySelectorAll('.jobs').forEach((block) => {
  new JobsBlock(block);
});

window.addEventListener('init', () => {
  document.querySelectorAll('.jobs').forEach((block) => {
    new JobsBlock(block);
  });
});

// Initialize the dynamic block preview (editor)
if (window.acf) {
  window.acf.addAction('render_block_preview/type=jobs', ($block, attributes) => {
    new JobsBlock($block.find('.jobs').get(0), attributes);
  });
}